<template>
    <header class="guideline-header">
        <slot name="back">
            <BaseBackButton to="/guidelines">Guidelines</BaseBackButton>

            <h1>
                <slot />
                {{ title }}
            </h1>

            <div
                v-if="$slots.navigation"
                class="guideline-header__navigation"
            >
                <slot name="navigation" />
            </div>
        </slot>
    </header>
</template>

<script setup>
defineProps({
    // eslint-disable-next-line vue/require-default-prop
    title: {
        type: String,
        required: false
    }
});
</script>

<style lang="less">
.guideline-header {
    .grid-bleed;
    .grid-container;
    background: var(--color-secondary-light);
    padding: 3rem 0;
    row-gap: 2.5rem;
}

.guideline-header__navigation {
    .card-grid();

    @media @q-lg-min {
        grid-template-columns: repeat(minmax(19rem, 1fr));
    }
}

.guideline-header__navigation [class^='vue-content-placeholders-'] + .vue-content-placeholders-img {
    margin-top: 0;
}
</style>
